import hex from '../Conversions';

export default function objectId()
{

  return hex(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => hex(Math.random() * 16));

}
